/**
 * @file step
 * @author zhaomiaoyuan
 */
import React, {useCallback} from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import CallingCardSelect from '../../components/CallingCard/callingCardSelect.tsx';
import VerifyParter from './verifyParter';
import VerifySelf from './verifySelf';
import VerifyGov from './verifyGov';
// import Step3 from '../mark/step3';
// import VerifyNetwork from './verifyNetwork';
import {recordProxy} from '../../util';

const VerifyMsgStep2 = (props) => {
    const {verifyMsgData, updateVerifyMsg} = props;
    /* eslint-disable */
    const rewrite = useCallback(() => {
        recordProxy('rewrite', 'click', verifyMsgData.authType + '');
        updateVerifyMsg({
            curStep: 1
        });
    });
    const onChangeCallback = (val) => {
        updateVerifyMsg({
            phone: val.phone,
            phoneName: val.name
        })
    };
    const {authType} = verifyMsgData;
    /* eslint-enable */
    return (
        <div className="verify-msg-step2">
            <CallingCardSelect
                data={{
                    phone: verifyMsgData.phone,
                    phoneName: verifyMsgData.phoneName,
                    titleName: verifyMsgData.titleName,
                    phoneList: verifyMsgData.phoneList
                }}
                rewrite={rewrite}
                callbackChange={onChangeCallback}
                updateData={updateVerifyMsg}
            />
            {/* 认证类型：1-特殊认证 2-企业自主认证 3-合作伙伴认证 */}
            {authType === 1 && <VerifyGov {...props} />}
            {authType === 2 && <VerifySelf {...props} />}
            {authType === 3 && <VerifyParter {...props} />}
        </div>
    );
};

VerifyMsgStep2.propTypes = {
    updateVerifyMsg: PropTypes.func,
    verifyMsgData: PropTypes.object,
    fetchCaptcha: PropTypes.func,
    fetchReport: PropTypes.func,
};

export default withRouter(VerifyMsgStep2);
